import type { ProjectId } from "features/shared/model/types";
import type { QueryClient } from "react-query";

import { invalidateConfigGroupQueries } from "features/shared/lib/technical-config-tab/api/invalidation";

import { ROOM_CONFIG_CACHE_KEYS } from "./cacheKeys";

export const invalidateRoomConfigCatalog = (queryClient: QueryClient) => {
  queryClient.invalidateQueries(ROOM_CONFIG_CACHE_KEYS.catalog);
};

export const invalidateRoomConfigQueries = (
  queryClient: QueryClient,
  projectId: ProjectId,
  roomFunctionValue?: string
) => {
  invalidateConfigGroupQueries(queryClient, ROOM_CONFIG_CACHE_KEYS, projectId, roomFunctionValue);
};
